import { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from 'styled-components';

import EvetroContainer from './EvetroContainer';
import AppScaleWrapper from './components/AppScaleWrapper';
import colors from './globalstyles/colors';
import sc from './globalstyles/style-constants';
import { ApplicationProvider } from './state/application/applicationStore';

const GlobalStyles = lazy(() => import('./globalstyles/GlobalStyles'));
const VendorStyles = lazy(() => import('./globalstyles/VendorStyles'));

const theme = {
  fontSize: 'calc(14px + 0.2vw)',
  color: {
    primary: colors.evetro_green
  }
};

const App = () => (
  <BrowserRouter basename="/">
    <ThemeProvider theme={theme}>
      <ApplicationProvider>
        <Suspense fallback={null}>
          <GlobalStyles colors={colors} sc={sc} />
          <VendorStyles colors={colors} sc={sc} />
        </Suspense>
        <AppScaleWrapper>
          <EvetroContainer />
        </AppScaleWrapper>
      </ApplicationProvider>
    </ThemeProvider>
  </BrowserRouter>
);
export default App;
